mutation groupCleanse($id: ID!, $tz: String) {
  groupCleanse(id: $id) {
    id
    name
    insertedAt(tz: $tz)
    updatedAt(tz: $tz)
    studentCount
    order
    orderNumerator
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      last
    }
    icon {
      id
      name
      displayName
    }
    color {
      id
      name
      displayName
    }
    orderDenominator
    students {
      id
      first
      last
    }
  }
}
